import React from 'react';
import { useTranslation } from 'react-i18next';
import SVGImage from '../layout/SVGImage';

interface DropdownSpinnerProps {
  className?: string;
}

export const DropdownSpinner: React.FC<DropdownSpinnerProps> = ({
  className,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <ul
        className={`${className} list-inside space-y-2 text-gray-500 dark:text-gray-400`}
      >
        <li className="group flex items-center">
          <div role="status">
            <SVGImage name="dropdown-spinner" />
          </div>
          {t('forecast.spinner')}
        </li>
      </ul>
    </div>
  );
};
